import { FiX } from "react-icons/fi";
import DashboardStyle from "../../../../../../dashboard/Styles/Dashboard.module.css";
import { FormProvider } from "react-hook-form";
import { FormTemplate } from "../../../../../Components/Forms/InputTemplate";
import { useGetSingleCommitteQuery, useGetSingleEmployeeQuery } from "../../../../../../api/hrApi";
import people from "../../../../../Images/grad.svg";

const EditDetailModal = ({
  isOpen,
  setIsOpen,
  onValidate = () => {},
  openNext = () => {},
  onBack = () => {},
  title,
  description,
  communityHead,
  communityMembers,
}) => {
  const { data } = useGetSingleEmployeeQuery(communityHead);
  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Edit </h4>
          <h1 className="text-[28px] font-[800]">Committee Details</h1>
          <p>Review committee details before editing KRAs.</p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        <div>
          <div>
            <FormProvider>
              <FormTemplate>
                <div className="w-full space-y-7">
                  <div className="grid">
                    <p className="text-[15px] font-[500]">Committee title</p>
                    <span>{title}</span>
                  </div>
                  <div className="grid">
                    <p className="text-[15px] font-[500]">
                      Committee description
                    </p>
                    <span>{description}</span>
                  </div>
                  <div className="flex justify-between items-end">
                    <div className="grid">
                      <p className="text-[15px] font-[500]">Committee Head</p>
                      <span>
                        {data?.responseObject?.firstName}{" "}
                        {data?.responseObject?.surname}
                      </span>
                    </div>
                    <div>
                      {data?.responseObject?.departmentName}
                    </div>
                  </div>
                  <div className="grid">
                    <p className="text-[15px] font-[500]">Committee Members</p>
                    <div className="space-y-2 grid">
                      {communityMembers.map((item) => (
                        <span key={item.id}>
                          {item.firstName ? 
                            `${item.firstName} ${item.surname}` : 
                            item.employeeName || item.name
                          }
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="flex justify-between my-4">
                    <button
                      type="button"
                      onClick={onBack}
                      className="bg-gray-100 text-gray-600 px-4 py-2 rounded-sm hover:bg-gray-200"
                    >
                      Back
                    </button>
                    <button
                      type="submit"
                      onClick={openNext}
                      className="bg-[#18BB0C1A] text-[#18BB0C] px-5 py-2 rounded-sm flex items-center space-x-2"
                    >
                      <img src={people} alt="people grag icon" />{" "}
                      <span>Edit KRA</span>
                    </button>
                  </div>
                </div>
              </FormTemplate>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDetailModal;
